import { useState } from "react";
import { FloppyDisk, Plus, Trash } from "@phosphor-icons/react";
import { closestCenter, DndContext } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { toast } from "sonner";

import { api, formatApiError } from "@/lib/api";
import { SortableEditorItem } from "@/components/SortableEditorItem";

function LessonEditor({ courseId, moduleId, lesson, onChanged }) {
  const [form, setForm] = useState(lesson);
  const save = async () => {
    try {
      await api.put(`/lms/courses/${courseId}/modules/${moduleId}/lessons/${lesson.id}`, form);
      toast.success("Lesson updated");
      onChanged();
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };
  const remove = async () => {
    try {
      await api.delete(`/lms/courses/${courseId}/modules/${moduleId}/lessons/${lesson.id}`);
      toast.success("Lesson removed");
      onChanged();
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };
  return <div className="lesson-editor" data-testid={`lesson-editor-${lesson.id}`}><input value={form.title} onChange={(event) => setForm({ ...form, title: event.target.value })} data-testid={`lesson-title-${lesson.id}`} /><input type="number" min="1" value={form.minutes} onChange={(event) => setForm({ ...form, minutes: Number(event.target.value) })} data-testid={`lesson-minutes-${lesson.id}`} /><input value={form.video_url || ""} placeholder="Optional YouTube URL" onChange={(event) => setForm({ ...form, video_url: event.target.value || null })} data-testid={`lesson-video-${lesson.id}`} /><button onClick={save} type="button" data-testid={`save-lesson-${lesson.id}`}><FloppyDisk aria-hidden="true" size={18} /></button><button onClick={remove} type="button" data-testid={`delete-lesson-${lesson.id}`}><Trash aria-hidden="true" size={18} /></button></div>;
}

export function CourseModuleEditor({ courseId, module, onChanged, onReorder }) {
  const [title, setTitle] = useState(module.title);
  const [lesson, setLesson] = useState({ title: "", minutes: 15, video_url: "" });
  const saveModule = async () => {
    try {
      await api.put(`/lms/courses/${courseId}/modules/${module.id}`, { title });
      toast.success("Module updated");
      onChanged();
    } catch (error) { toast.error(formatApiError(error)); }
  };
  const deleteModule = async () => {
    try {
      await api.delete(`/lms/courses/${courseId}/modules/${module.id}`);
      toast.success("Module removed");
      onChanged();
    } catch (error) { toast.error(formatApiError(error)); }
  };
  const addLesson = async (event) => {
    event.preventDefault();
    try {
      await api.post(`/lms/courses/${courseId}/modules/${module.id}/lessons`, lesson);
      setLesson({ title: "", minutes: 15, video_url: "" });
      toast.success("Lesson added");
      onChanged();
    } catch (error) { toast.error(formatApiError(error)); }
  };
  return <section className="module-editor" data-testid={`module-editor-${module.id}`}><div className="module-editor-heading"><input value={title} onChange={(event) => setTitle(event.target.value)} data-testid={`module-title-${module.id}`} /><button onClick={saveModule} type="button" data-testid={`save-module-${module.id}`}><FloppyDisk aria-hidden="true" size={18} /></button><button onClick={deleteModule} type="button" data-testid={`delete-module-${module.id}`}><Trash aria-hidden="true" size={18} /></button></div><DndContext collisionDetection={closestCenter} onDragEnd={onReorder}><SortableContext items={module.lessons.map((item) => item.id)} strategy={verticalListSortingStrategy}><div className="lesson-editor-list">{module.lessons.map((item) => <SortableEditorItem id={item.id} key={item.id} testPrefix="drag-lesson"><LessonEditor courseId={courseId} moduleId={module.id} lesson={item} onChanged={onChanged} /></SortableEditorItem>)}</div></SortableContext></DndContext><form className="add-lesson-form" onSubmit={addLesson}><input value={lesson.title} placeholder="Lesson title" onChange={(event) => setLesson({ ...lesson, title: event.target.value })} required data-testid={`new-lesson-title-${module.id}`} /><input type="number" min="1" value={lesson.minutes} onChange={(event) => setLesson({ ...lesson, minutes: Number(event.target.value) })} required data-testid={`new-lesson-minutes-${module.id}`} /><input value={lesson.video_url} placeholder="Optional YouTube URL" onChange={(event) => setLesson({ ...lesson, video_url: event.target.value })} data-testid={`new-lesson-video-${module.id}`} /><button className="outline-button" data-testid={`add-lesson-${module.id}`}><Plus aria-hidden="true" size={18} />Add lesson</button></form></section>;
}